// work orders
export const getAllWorkOrders = "/workorders";
export const workOrderDetail = "/workorders/show";
export const workOrderAssignSupervisor = "/workorders/step/assignSupervisor";
export const workOrderConfirmSupervisor = "/workorders/step/confirmSupervisor";
export const workOrderAssignTechnician = "/workorders/step/assignTechnician";
export const workOrderConfirmTechnician = "/workorders/step/confirmTechnician";
export const workOrderResolveTechnician = "/workorders/step/resolveTechnician";
export const workOrderResolveTechnicianAsDraft = "/workorders/step/resolveTechnician/draft";
export const workOrderApprovalSupervisor = "/workorders/step/approvalSupervisor";
export const supervisorSparePartApproval = "/workorders/step/supervisorSparePartApproval";
export const warehouseManagerApprovalPO = "/workorders/step/wareHouserManagerApproval";

export const workOrderRating = "/workorders/rating";
export const workOrderApprovalQA = "/workorders/step/approvalQA";
export const workOrderApprovalRequestor = "/workorders/step/approvalRequestor";
export const workOrderApprovalHead = "/workorders/step/hospitalHeadApproval";
export const workOrderCreate = "/workorders/create";
export const getTechnicianFormOptions = "/workorders/technician/form/";
export const exportWorkOrderPDF = "workorders/export/pdf";
export const exportWorkOrderListPDF = "/workorders/list/export/pdf";
export const exportUsers = "/users/1_export";

// non-medical workorders

export const workOrderNonMedAssignHod = "/workorders/nonmedical/step/assignHods";
export const workOrderNonMedAssignTechnician = "/workorders/nonmedical/step/assignTechnicians";
export const workOrderNonMedConfirmTechnician = "/workorders/nonmedical/step/confirmTechnician";
export const workOrderNonMedResolveTechnician = "/workorders/nonmedical/step/resolveTechnician";
export const workOrderNonMedHodApproval = "/workorders/nonmedical/step/hodApproval";
export const workOrderNonMedSiteManagerApproval = "/workorders/nonmedical/step/siteManagerCallCenterApproval";
export const workOrderNonMedApprovalQA = "/workorders/nonmedical/step/mohEngineer";
export const workOrderResolveNonMedTechnicianAsDraft = "/workorders/nonmedical/step/resolveTechnician/draft";
export const workOrderNonMedNonQrCreation = "/workorders/createNonQrWO";

// Asset Acceptance
export const getAllAssets = "/acceptanceCertificate/inventory/index";
export const getAsset = "/acceptanceCertificate/inventory/showSpecificInventories?";
export const Initiation = "/acceptanceCertificate/step/initiateAC";
export const assignWarehouseManager = "/acceptanceCertificate/step/assignWarehouseManager";
export const Installation = "/acceptanceCertificate/step/assetSupplierInstallation";
export const warehouseManagerApproval = "/acceptanceCertificate/step/warehouseManagerApproval";
export const assignInstallationLocation = "/acceptanceCertificate/step/assignSiteDepatmentByManagement";
export const biomedManagementApproval = "/acceptanceCertificate/step/bioMedManagerApproval";
export const clinicalHeadApproval = "/acceptanceCertificate/step/clinicalDivisionHeadApproval";
export const hospitalDirectorApproval = "/acceptanceCertificate/step/hospitalDirectorApproval";
export const biomedEngineerApproval = "/acceptanceCertificate/step/biomedicalEngineerApproval";
export const downloadAcceptanceCertificate = "/acceptanceCertificate/step/downloadPdf";
export const trainingCompleteApproval = "/acceptanceCertificate/step/trainingCompleteApproval";
export const createBulkInventory = "/acceptanceCertificate/inventory/store";
export const getGroupedInventory = "/acceptanceCertificate/inventory/groupedData";
export const acceptanceCertificateDownload = "/acceptanceCertificate/step/downloadAc";

export const updateGroupInventory = "/acceptanceCertificate/inventory/update";
export const updateInstallerInventory = "/acceptanceCertificate/inventory/updateMultipleInventories";

// Scrapping

export const scrappingDetail = "/scrapping/inventory/getAssetDetails";
export const initiateScrappingRequest = "/scrapping/step/initiateScrappingRequest";
export const clusterEquipmentDepartmentApproval = "/scrapping/step/clusterEquipmentDepartmentApproval";
export const clusterContractDepartmentMemberApproval = "/scrapping/step/clusterContractDepartmentMemberApproval";
export const clusterContractDepartmentManagerApproval = "/scrapping/step/clusterContractDepartmentManagerApproval";
export const clusterEquipmentCommitteeMemberApproval = "/scrapping/step/clusterEquipmentCommitteeMemberApproval";
export const clusterEquipmentCommitteeChairmanApproval = "/scrapping/step/clusterEquipmentCommitteeChairmanApproval";
export const downloadScrappingCertificate = "/scrapping/step/downloadScrappingCertificate";

export const scrappingDetailClassC = "/scrappingClassC/inventory/getAssetDetails";
export const initiateScrappingRequestClassC = "/scrappingClassC/step/initiateScrapping";
export const submitScrappingRequestClassC = "/scrappingClassC/step/submitScrappingApplication";
export const mohApprovalScrappingRequestClassC = "/scrappingClassC/step/mohApproval";
export const deptHeadScrappingRequestClassC = "/scrappingClassC/step/departmentHeadApproval";
export const warehouseApprovalScrappingRequestClassC = "/scrappingClassC/step/warehouseApproval";
export const downloadScrappingCertificateClassC = "/scrappingClassC/step/downloadScrappingCertificateClassC";

// Dashboard

export const getDashboardOverview = "/dashboard/overview";
export const getDashboardWorkorderOverview = "/dashboard/overview/workOrder";
export const getDashboardReport = "/dashboard/downloadPdf";
export const getMapData = "/dashboard/geomap";
export const getMapFormOptions = "/dashboard/geomap/formOptions";
export const inventoryAnalytics = "/dashboard/inventoryAnalytics";
export const generalExcelImport = "/excel/import/generalImport";
export const getImportLogsUrl = "/import/log";
export const getRatingOverview = "/dashboard/overview/workOrder/ratingsSummary";
export const getRatingPercentage = "/dashboard/overview/workOrder/ratingsPercentage";
export const pmComplianceAggregated = "/dashboard/pmComplianceAggregated";
export const pmComplianceMonthly = "/dashboard/pmComplianceMonthly";
export const firstTimeFixRateKpi = "/dashboard/firstTimeFixRate";
export const dashboardWorkOrderFilter = "/workorders/dashboard/work-orders";
export const dashboardSystemRating = "/dashboard/overview/systemRating";
export const getFeedbackStats = "/dashboard/overview/getFeedbackStats";
export const getFeedbackPercentage = "/dashboard/overview/feedbackPercentage";
export const getAllFeedback = "/dashboard/overview/getAllFeedbacks";
export const getFeedbackUsersList = "/dashboard/overview/getFeedbackUsersRole";
export const getInventorySuppliersList = "/dashboard/getsuppliers";

//Reports

export const getInventoryCmPm="/dashboard/getInventoryCmPm"
export const getRepeatedFailures = "/dashboard/repeatedFailures";
export const getAnnualFailures = "/dashboard/annualFailures";
export const getWorkOrdersStats ="/dashboard/getRejectedAndRedirectedWorkOrders";
export const getPmCompliance = "/dashboard/getLabsWithLowPMCompliance";
export const getUtilization = "/dashboard/techniciansUtilization";

export const getAvgDowntime = "/dashboard/average-downtime";
export const getEquipmentDowntime = "/dashboard/equipment-down-for-maintenance";
export const getTotalResponseTime = "/dashboard/hmc-response-time";
export const getMohResponseTime = "/dashboard/moh-enigneer-average-downtime";

// EOD Reporting
export const eodDashboard = "/eod/dashboard";
export const eodLookups = "/eod/lookups";
export const eodReports = "/eod/reports";
export const eodInventories = "/eod/inventories";
export const eodInventoryImport = "/eod/inventories/import";
export const eodInventoryTemplate = "/eod/inventories/template";
export const eodReportShow = "/eod/reports/show";
export const eodReportToday = "/eod/reports/today";
export const eodReportSubmit = "/eod/reports/submit";



// Auth
export const signIn = "/login";
export const forgotPassword = "/password/email";
export const forgotPasswordSmsSend = "/password/sendSMS";
export const resetPasswordUA = "/password/reset";
export const resetPassword = "/users/setPassword";

// users
export const getAllUsers = "/users";
export const getUser = "/users/show";
export const updateUser = "/users/update";
export const createUser = "/users/create";
export const activateUsers = "/users/active";
export const userSubRoles = "/users/create/subroles";
export const userFormOptions = "/users/formOptions";

// Inventories
export const createInventory = "/inventories";
export const getInventory = "/inventories/show";
export const getAllInventories = "/inventories";
export const getInventoryById = "/inventories/find";
export const updateInventory = "/inventories/update";
export const exportInventory = "/excel/export/workorderCreationUrls";
export const inventoryFormOptions = "/inventories/formOptions?withEquipments=1";
export const inventoriesPlanning = "/assetPlanning/update";
export const inventoriesPMCalender = "/inventories/pmCalendar";
export const inventoriesPMCalenderExport = "/inventories/pmCalendar/inventories";

// Regions
export const getRegion = "/regions/show";
export const createRegion = "/regions/create";
export const updateRegion = "/regions/update";
export const getRegionsList = "/regions?per_page=0&page=0";
export const exportRegionsExcel = "/regions/export/excel";

// Lab
export const allSites = "/sites";
export const getSite = "/sites/show";
export const updateSite = "/sites/update";
export const createSite = "/sites/create";
export const siteFormOptions = "/sites/formOptions";
export const sitesList = "/sites?per_page=0&page=0";
export const exportSitesExcel = "/sites/export/excel";

// hmc
export const getHMCs = "/hmcs";
export const getHMC = "/hmcs/show";
export const updateHMC = "/hmcs/update";
export const createHMC = "/hmcs/create";
export const hmcFormOptions = "/hmcs/formOptions";

// Equipment
export const getEquipment = "/equipments/show";
export const updateEquipment = "/equipments/update";
export const createEquipment = "/equipments/create";
export const equipmentFormOptions = "/equipments/formOptions";
export const getEquipmentsList = "/equipments?per_page=0&page=0";
export const exportEquipmentsExcel = "/equipments/export/excel";

// Manufacturer
export const getManufacturer = "/manufacturers/show";
export const createManufacturer = "/manufacturers/create";
export const updateManufacturer = "/manufacturers/update";
export const getManufacturersList = "/manufacturers?per_page=0&page=0";

// SUPPORT
export const supportLogin = "/login";
export const supportStoreTickets = "/store-tickets";
export const supportGetDynamicFields = "/team-dynamicfields";

// SITE DEPARTMENTS
export const getDepartmentsList = "/siteDepartments";
export const getDepartment = "/siteDepartments/show";
export const createDepartment = "/siteDepartments/create";
export const updateDepartment = "/siteDepartments/update";
export const exportSiteDepartmentsExcel = "/siteDepartments/export/excel";

// Maintenance DEPARTMENTS
export const getMaintenanceDepartmentsList = "/maintenanceDepartments";
export const getMaintenanceDepartment = "/maintenanceDepartments/show";
export const createMaintenanceDepartment = "/maintenanceDepartments/create";
export const updateMaintenanceDepartment = "/maintenanceDepartments/update";
export const exportMaintenanceDepartmentsExcel = "/maintenanceDepartments/export/excel";

// Work classification
export const getWorkClassification = "/users/formOptions";

// Divisions
// export const getDivisionsList = "/divisions";
export const getDivision = "/division/show";
export const createDivision = "/division/create";
export const updateDivision = "/division/update";

// Cluster
export const getClusterList = "/clusters";
export const getCluster = "/clusters/show";
export const createCluster = "/clusters/create";
export const updateCluster = "/clusters/update";
export const exportClustersExcel = "/clusters/export/excel";

// Sub departments
export const getSubDepartmentList = "/subDepartments";
export const getSubDepartment = "/subDepartments/show";
export const createSubDepartment = "/subDepartments/create";
export const updateSubDepartment = "/subDepartments/update";
export const exportSubDepartmentsExcel = "/subDepartments/export/excel";

// ORGANIZATION ADMINS
export const assignLabs = "/organization/admins/assignLabs";
export const getOrganizationAdminsList = "/organization/admins";
export const getOrganizationAdmin = "/organization/admins/show";
export const createOrganizationAdmin = "/organization/admins/create";
export const updateOrganizationAdmin = "/organization/admins/update";

// SPARE PARTS
export const getSparePartsList = "/spareParts";
export const getSparePart = "/spareParts/show";
export const createSparePart = "/spareParts/create";
export const updateSparePart = "/spareParts/update";
export const getSparePartNames = "/spareParts/partNames";

//profie

export const checkpass = "/profilePasswordCheck";
export const passwordUpdate = "/profilePasswordUpdate";
export const profilePageUpdate = "/profilePageUpdate";


//uploadfile
export const fileupload = "/excel/import/checkImportFile";
export const bulkupload = "/mohInventory/exportedToApm";

//bulk user upload
export const bulkUploadUsers = "/excel/import/userImportFile";
export const mohInventory = "mohInventory";
export const mohInventorypost = "/mohInventory/exportedToApm";
